import React,{ useState,useEffect } from 'react';
import {
    Paper,
    Typography
} from '@material-ui/core';
import Map from '../components/Map';
import { useSelector} from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { 
    language
} from "config";

const Dashboard = () => {
    const [mylocation, setMylocation] = useState(null);
    const [locations, setLocations] = useState([]);
    const usersdata = useSelector(state => state.usersdata);
    const bookinglistdata = useSelector(state => state.bookinglistdata);
    const auth = useSelector(state => state.auth);

    useEffect(()=>{
        if(mylocation == null){
            navigator.geolocation.getCurrentPosition(
                position => setMylocation({ 
                    lat: 35.51522,
                    lng: 24.019575,
                }), 
                err => console.log(err)
            );
        }
    },[mylocation]);


    useEffect(()=>{
        if(usersdata.users){
            const drivers = usersdata.users.filter(user => user.usertype ==='driver' && ((user.fleetadmin === auth.info.uid && auth.info.profile.usertype === 'fleetadmin')|| auth.info.profile.usertype === 'admin'));  
            let locs = [];
            for(let i=0;i<drivers.length;i++){
                if(drivers[i].approved && drivers[i].driverActiveStatus && drivers[i].location){
                    locs.push({
                        id:i,
                        lat:drivers[i].location.lat,
                        lng:drivers[i].location.lng,
                        drivername:drivers[i].firstName + ' ' + drivers[i].lastName
                    });
                }
            }
            setLocations(locs);
        }
    },[usersdata.users,auth.info.profile,auth.info.uid]);

    return (
        bookinglistdata.loading || usersdata.loading ? <CircularLoading/> :
        <div>
            { mylocation?
            <Paper>
                {/* <Typography variant="h5" style={{margin:"5px 0 0 15px"}}>{language.real_time_driver_section_text}</Typography> */}
                <Map mapcenter={mylocation} locations={locations}
                    loadingElement={<div style={{ height: `420px` }} />}
                    containerElement={<div style={{ height: `420px` }} />}
                    mapElement={<div style={{ height: `420px` }} />}
                />
            </Paper>
            :
            <Typography variant="inherit" style={{margin:"20px 0 0 15px",color:'#5CD85A'}}>{language.allow_location}</Typography>
            }
        </div>
        
    )
}

export default Dashboard;